import styled from 'styled-components';
import { Switch } from 'antd';

import * as Colors from '../../attrs/colors';

export const Container = styled.div`
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.span`
  display: inline-block;
  padding: 0 1rem;
  font-weight: bold;
`;

export const StyledSwitch = styled(Switch)`
  background: ${Colors.BLACK};
`;
